/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Welcomesetyourpassword3Inputs */

const en_welcomesetyourpassword3 = /** @type {(inputs: Welcomesetyourpassword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome! Set your password`)
};

const de_welcomesetyourpassword3 = /** @type {(inputs: Welcomesetyourpassword3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen! Lege dein Passwort fest`)
};

/**
* | output |
* | --- |
* | "Welcome! Set your password" |
*
* @param {Welcomesetyourpassword3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const welcomesetyourpassword3 = /** @type {((inputs?: Welcomesetyourpassword3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Welcomesetyourpassword3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_welcomesetyourpassword3(inputs)
	return de_welcomesetyourpassword3(inputs)
});
export { welcomesetyourpassword3 as "welcomeSetYourPassword" }